import { SiteSiteMetadataAddress, SiteSiteMetadata } from '../../types/graphql-types'

export const parseAddress = (address?: SiteSiteMetadataAddress | null) =>
  `${address?.addressLocality}${address?.addressRegion}${address?.streetAddress}`

export const parseTel = (tel: string) => tel.replace(/-/g, '')

export const parseMetaTitle = (meta?: SiteSiteMetadata | null) =>
  `${meta?.title} - ${meta?.address?.addressLocality}${meta?.address?.addressRegion}の${meta?.serviceName}`
